import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogComponent } from '../modules/shared/components/dialog/dialog.component';
import { AppPaths } from '../enums/app-paths.enum';
import { AppointmentService } from '../services/appointment.service';
import { AuthService } from '../services/auth.service';
import { CustomRouter } from '../routers/custom-router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private customRouter: CustomRouter,
    private matDialog: MatDialog,
    private authService: AuthService,
    private appointmentService: AppointmentService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    var self = this;
    if(this.authService.isRefreshingToken()) {
      this.authService.addRefreshTokenCallback((success: boolean) => {
        if(!success) self.expiredToken(state);
      })
      return true;
    }
    return this.expiredToken(state);
  }

  private expiredToken(state: RouterStateSnapshot) {
    if(this.appointmentService.inAppointment()) return this.customRouter.navigate([AppPaths.APPOINTMENT_END])
    this.matDialog.closeAll();
    this.matDialog.open(DialogComponent, {
      maxWidth: 350,
      disableClose: true,
      data: {
        title: "expired_session_title",
        message: "expired_session_message",
        canCancel: false,
        actions: [
          {
            message: "permissions_accept",
            action: () => {},
          }
        ]
      }
    });
    this.authService.logout();
    return this.customRouter.createUrlTree([`/${AppPaths.AUTH}`], { queryParams: { returnUrl: state.url } });
  }

}
